import EditIcon from 'assets/svgs/EditIcon';
import GlobalCustomButton from 'modules/Common/Components/GlobalCustomButton';
import styled from 'styled-components';
import SummarySection from './Section/SummarySection';
import FormSubmissionSection from './Section/FormSubmissionSection';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { formAudienceResetContacts, formAudienceResetFilter, formAudienceResetSearchAction, formAudienceResetSearchContacts } from './actions';
import { getQueryFormId } from 'modules/EmailBrowser/utils';

const Wrapper = styled.div`
  width: 100%;
  .edit-icon {
    width: 12px;
    height: 12px;
  }
  .summary-label-url {
    color: #424b50;
  }
  .submission-field-wapper {
    margin-top: 4px;
    :hover {
      cursor: pointer;
    }
  }
  .form-submission-card {
    margin: 4px 0 0 0;
  }
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .summary-text {
      font-size: 13px;
    }
    .ant-typography {
      font-size: 13px !important;
    }
    .ant-typography + p {
      font-size: 13px !important;
    }
    .summary-label {
      font-size: 15px;
    }
    .summary-label-url {
      font-size: 15px;
    }
    .submission-label {
      font-size: 15px;
    }
  }
`;
const SummaryHeader = styled.div`
  min-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
const Title = styled.div`
  color: #424b50;
  font-family: 'Roboto Slab';
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px;
  letter-spacing: -0.65px;
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    font-size: 20px !important;
  }
`;

const FormSummary: React.FC = () => {
  const history = useHistory();
  const formId = getQueryFormId();

  useEffect(() => {
    //Reset filter on unmounting
    return () => {
      const pathname = window.location.href;
      if (!pathname.includes(`/forms/?form_id=${formId}`)) {
        formAudienceResetFilter();
        formAudienceResetSearchAction();
        formAudienceResetContacts();
        formAudienceResetSearchContacts();
      }
    };
  }, []);

  return (
    <>
      <Wrapper>
        <SummaryHeader>
          <Title>Summary</Title>
          <GlobalCustomButton
            btnText={'Edit Form Handler'}
            disabled={false}
            onClick={() => history.push(`/settings/forms/create_form?form_id=${formId}`)}
            border={'none'}
            padding={'8px 16px'}
            bgColor={'#1EC252'}
            color={'#fff'}
            customIcon={<EditIcon fillColor="#fff" />}
            borderRadius={'6px'}
            fontSize={'16px'}
            boxShadow={''}
            width="auto"
          />
        </SummaryHeader>
        <SummarySection />
        <FormSubmissionSection />
      </Wrapper>
    </>
  );
};

export default FormSummary;
